"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentPriceColor = void 0;
const getCurrentPriceColor = (theme, oldPriceVisible) => oldPriceVisible ? theme.palette.offer.main : theme.palette.text.primary;
exports.getCurrentPriceColor = getCurrentPriceColor;
//# sourceMappingURL=utils.js.map